import {
  App,
  PaymentTransactionsByProcessingStatusFilterInput,
  PaymentTransactionsByProcessingStatusOrderByInput,
  PaymentTransactionsBySortBy,
  ProcessingStatus,
  SaPaymentTransactionsQuery,
  SortOrder,
  useInfiniteGraphQLQuery,
  useSaPaymentTransactionsQuery,
} from '../../index';

export const useInfiniteSAPaymentTransactionsQuery = (
  processingStatus: ProcessingStatus,
  filter: PaymentTransactionsByProcessingStatusFilterInput,
  pageSize: number,
  app?: App,
) => {
  const getNextPageParam = (lastPage: SaPaymentTransactionsQuery) =>
    lastPage.paymentTransactionsByProcessingStatus.nextToken;

  const orderBy: PaymentTransactionsByProcessingStatusOrderByInput = {
    order: SortOrder.Desc,
    by: PaymentTransactionsBySortBy.CreatedAt,
  };

  const getVariables = ({ pageParam }: { pageParam?: string | null }) => ({
    filter,
    nextToken: pageParam,
    orderBy,
    processingStatus,
    pageSize,
    app,
  });

  return useInfiniteGraphQLQuery(useSaPaymentTransactionsQuery, getVariables, {
    getNextPageParam,
  });
};

export type TPaymentCsvArgs = {
  startDate: string;
  endDate: string;
  processingStatus: ProcessingStatus;
  app?: App;
};

export type TPaymentCsvResult = {
  blob: Blob;
  filename?: string;
};

export const fetchCsv = async ({
  startDate,
  endDate,
  processingStatus,
  app,
}: TPaymentCsvArgs): Promise<TPaymentCsvResult | null> => {
  const baseEndpoint = process.env.NX_AWS_BASE_ENDPOINT;
  if (!baseEndpoint) {
    throw new Error('NX_AWS_BASE_ENDPOINT is not set');
  }

  const body = {
    startDate,
    endDate,
    processingStatus,
  };

  if (app) {
    Object.assign(body, { app });
  }

  const res = await fetch(`${baseEndpoint}/payment/export`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'preview-token': '1',
    },
    body: JSON.stringify(body),
  });

  if (res.headers.get('content-type')?.includes('text/csv')) {
    const filename = res.headers.get('content-disposition')?.split('filename=')[1];

    const blob = await res.blob();
    return { blob, filename };
  }

  return null;
};
